if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const selectedContext = this.getSelectedVariantContext();
        this.syncSelectedVariantId(selectedContext);
        this.syncSelectedSizeProperty(selectedContext);
        this.syncSelectedSkuProperty(selectedContext);

        const formData = new FormData(this.form);
        if (selectedContext.selectedVariant && selectedContext.selectedVariant.id) {
          formData.set('id', String(selectedContext.selectedVariant.id));
        }

        if (selectedContext.sizePropertyValue) {
          formData.set('properties[Talla]', selectedContext.sizePropertyValue);
        } else {
          formData.delete('properties[Talla]');
        }

        const selectedVariantSku =
          this.getSelectedVariantPublicSku(selectedContext) ||
          this.form.querySelector('[data-line-item-sku-property]')?.value ||
          '';
        formData.delete('properties[SKU]');
        formData.delete('properties[SKU de color]');
        if (selectedVariantSku) {
          formData.set('properties[SKU de variante]', selectedVariantSku);
        } else {
          formData.delete('properties[SKU de variante]');
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getPickerRoot() {
        return (
          document.querySelector(`variant-radios[data-section="${this.dataset.sectionId}"]`) ||
          document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"]`)
        );
      }

      getSelectedVariantContext() {
        const pickerRoot = this.getPickerRoot();
        if (!pickerRoot) {
          return {
            pickerRoot: null,
            selectedVariant: null,
            sizePropertyValue: '',
          };
        }

        let selectedVariant = null;
        let selectedOptions = [];

        if (pickerRoot.tagName === 'VARIANT-RADIOS') {
          const fieldsets = Array.from(pickerRoot.querySelectorAll('fieldset'));
          selectedOptions = fieldsets
            .map((fieldset) => {
              const checkedInput = fieldset.querySelector('input:checked');
              return checkedInput ? checkedInput.value : null;
            })
            .filter(Boolean);
        } else {
          selectedOptions = Array.from(pickerRoot.querySelectorAll('select'))
            .map((select) => select.value)
            .filter(Boolean);
        }

        const variantDataScript = pickerRoot.querySelector('[type="application/json"]');
        if (variantDataScript && selectedOptions.length > 0) {
          try {
            const variantData = JSON.parse(variantDataScript.textContent);
            selectedVariant = variantData.find((variant) => {
              return Array.isArray(variant.options)
                ? !variant.options.some((optionValue, index) => selectedOptions[index] !== optionValue)
                : false;
            });
          } catch (error) {
            selectedVariant = null;
          }
        }

        if (!selectedVariant && pickerRoot.currentVariant && pickerRoot.currentVariant.id) {
          selectedVariant = pickerRoot.currentVariant;
        }

        const sizeFieldset = pickerRoot.querySelector('.product-form__input--size');
        let sizePropertyValue = '';

        if (sizeFieldset) {
          const checkedInput = sizeFieldset.querySelector('input[type="radio"]:checked');
          const checkedLabel = checkedInput ? checkedInput.nextElementSibling : null;

          if (checkedInput && checkedLabel) {
            const sizeEu = checkedLabel.getAttribute('data-size-eu') || checkedLabel.getAttribute('data-current-size') || checkedInput.value;
            const sizeMx = checkedLabel.getAttribute('data-size-mx') || sizeEu;
            const sizeUs = checkedLabel.getAttribute('data-size-us') || sizeMx;
            const activeSystem = sizeFieldset.dataset.activeSizeSystem || 'mx';

            sizePropertyValue = `EU ${sizeEu}`;

            if (activeSystem === 'mx' && sizeMx) {
              sizePropertyValue = sizeMx === sizeEu ? `MX ${sizeMx}` : `MX ${sizeMx} (EU ${sizeEu})`;
            } else if (activeSystem === 'us' && sizeUs) {
              sizePropertyValue = sizeUs === sizeEu ? `US ${sizeUs}` : `US ${sizeUs} (EU ${sizeEu})`;
            }
          }
        }

        return {
          pickerRoot,
          selectedVariant,
          sizePropertyValue,
        };
      }

      syncSelectedSizeProperty(context = this.getSelectedVariantContext()) {
        const sizePropertyInput = this.form.querySelector('[data-line-item-size-property]');
        if (!sizePropertyInput) return;

        if (!context.sizePropertyValue) {
          sizePropertyInput.value = '';
          sizePropertyInput.disabled = true;
          return;
        }

        sizePropertyInput.value = context.sizePropertyValue;
        sizePropertyInput.disabled = false;
      }

      syncSelectedSkuProperty(context = this.getSelectedVariantContext()) {
        const skuPropertyInput = this.form.querySelector('[data-line-item-sku-property]');
        if (!skuPropertyInput) return;

        if (!context.selectedVariant) {
          skuPropertyInput.disabled = !skuPropertyInput.value;
          return;
        }

        const variantSku = this.getSelectedVariantPublicSku(context);
        skuPropertyInput.value = variantSku;
        skuPropertyInput.disabled = !variantSku;
      }

      getSelectedVariantPublicSku(context = this.getSelectedVariantContext()) {
        if (!context.selectedVariant) return '';

        const variantId = String(context.selectedVariant.id || '');
        const skuMapScript = context.pickerRoot?.querySelector('[data-variant-public-skus]');
        if (!skuMapScript || !variantId) return '';

        try {
          const skuMap = JSON.parse(skuMapScript.textContent);
          return String(skuMap[variantId] || '').trim();
        } catch (error) {
          return '';
        }
      }

      syncSelectedVariantId(context = this.getSelectedVariantContext()) {
        const variantInput = this.form.querySelector('input[name="id"]');
        if (!variantInput || !context.selectedVariant || !context.selectedVariant.id) return;

        variantInput.value = context.selectedVariant.id;
        variantInput.setAttribute('value', context.selectedVariant.id);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );

  const getPublicSkuFromPicker = (variant, sectionId = '') => {
    const variantId = String(variant?.id || '');
    if (!variantId) return '';

    const skuMapScript =
      (sectionId &&
        document.querySelector(
          `#variant-radios-${CSS.escape(sectionId)} [data-variant-public-skus], #variant-selects-${CSS.escape(sectionId)} [data-variant-public-skus]`
        )) ||
      document.querySelector('[data-variant-public-skus]');
    if (!skuMapScript) return '';

    try {
      const skuMap = JSON.parse(skuMapScript.textContent);
      return String(skuMap[variantId] || '').trim();
    } catch (error) {
      return '';
    }
  };

  let selectedVariantSku = document.querySelector('[data-line-item-sku-property]')?.value || '';

  const syncSelectedVariantSku = (variant, sectionId = '') => {
    selectedVariantSku = getPublicSkuFromPicker(variant, sectionId);

    document.querySelectorAll('[data-line-item-sku-property]').forEach((skuPropertyInput) => {
      skuPropertyInput.value = selectedVariantSku;
      skuPropertyInput.disabled = !selectedVariantSku;
    });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      syncSelectedVariantSku(event?.data?.variant, event?.data?.sectionId);
    });
  }

  document.addEventListener('variant:changed', (event) => {
    syncSelectedVariantSku(event.detail?.variant);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.id.startsWith('sticky-product-form-')) return;

      let skuPropertyInput = form.querySelector('[data-sticky-line-item-sku-property]');
      if (!skuPropertyInput) {
        skuPropertyInput = document.createElement('input');
        skuPropertyInput.type = 'hidden';
        skuPropertyInput.name = 'properties[SKU de variante]';
        skuPropertyInput.dataset.stickyLineItemSkuProperty = '';
        form.appendChild(skuPropertyInput);
      }

      skuPropertyInput.value = selectedVariantSku;
      skuPropertyInput.disabled = !selectedVariantSku;
    },
    true
  );
}
